import { ApplicationStatus } from "shared/types";

export const applicationStatusTitle = ({
  status,
  isAutoCanceled,
  autoApproved
}: {
  status?: ApplicationStatus;
  isAutoCanceled?: boolean;
  autoApproved?: boolean;
}): string => {
  if (!status) return "Invited";
  if (status === ApplicationStatus.Canceled && isAutoCanceled)
    return "Auto-canceled";
  if (status === ApplicationStatus.Approved && autoApproved)
    return "Auto-approved";

  switch (status) {
    case ApplicationStatus.Started:
      return "Started";
    case ApplicationStatus.Pending:
      return "Not submitted";
    case ApplicationStatus.PartiallySubmitted:
      return "Partially submitted";
    case ApplicationStatus.Submitted:
      return "Submitted";
    case ApplicationStatus.Canceled:
      return "Canceled";
    case ApplicationStatus.Approved:
      return "Approved";
    case ApplicationStatus.ConditionalApproved:
      return "Cond. Approved";
    case ApplicationStatus.Rejected:
      return "Declined";
    case ApplicationStatus.OnHold:
      return "On hold";
    default:
      return status;
  }
};
